export class UnsupportedRendererError extends Error {
  readonly errorType: FatalErrorType.UNSUPPORTED_RENDERER;

  constructor(
    readonly renderer: string,
    readonly vendor: string,
  ) {
    super(FatalErrorType.UNSUPPORTED_RENDERER);
    this.errorType = FatalErrorType.UNSUPPORTED_RENDERER;
  }
}

export class WebGLUnavailableError extends Error {
  readonly errorType: FatalErrorType.WEBGL_UNAVAILABLE;

  constructor() {
    super(FatalErrorType.WEBGL_UNAVAILABLE);
    this.errorType = FatalErrorType.WEBGL_UNAVAILABLE;
  }
}

export enum FatalErrorType {
  WEBGL_UNAVAILABLE = "WebGL 2.0 unavailable",
  UNSUPPORTED_RENDERER = "Unsupported renderer",
}

export type FatalError = UnsupportedRendererError | WebGLUnavailableError;
